
Vue.component("public_qa_modal", {
  props: {
    course_id: {
      type: String,
      required: true,
      default: ""
    },
    topic_id: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      publicValue: "1",
      visible: false,
    }
  },
  methods: {
    handleOk() {
      API.updateQaStatus({ link_id: this.course_id, topic_id: this.topic_id, permissions: this.publicValue }).then(res => {
        if (res.error_msg === "Success") {
          this.$message.success(this.$t("公开成功！"));
          this.$emit("onPublic", this.topic_id, this.publicValue);
          this.visible = false;
        } else {
          this.$message.error(this.$t("公开失败!"));
        }
      })
    }
  },
  template: `
    <el-dialog custom-class="public_courseqa_modal" :visible.sync="visible" @closed="() => {this.publicValue = '1'}"  :title="$t('公开问答')" width="500px">
      <div>{{$t('请确认问答公开后')}}:</div>
      <el-radio-group v-model="publicValue">
        <el-radio label="1">{{$t('仅教师团队可继续回复')}}</el-radio>
        <el-radio label="2">{{$t('仅提问人和教师团队可继续回复')}}</el-radio>
        <el-radio label="3">{{$t('所有人可回复')}}</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{$t('取消')}}</el-button>
        <el-button type="primary" @click="handleOk">{{$t('确定')}}</el-button>
      </div>
    </el-dialog>
  `
})